
<div class="hmf-grid hmf-mt-xs hmf-mx-0 top-padding">
  <div class="hmf-col hmf-span-12 hmf-px-s-0 center-text">
    <img src="assets/image/no_state_favorites.svg" class="reactionLoveFilledIcon" alt="empty favorites Icon">
    @if (!isListRoute()) {
      <p class="hmf-header-bold-l">Sign in to Save & View Favorites</p>
      <p class="margin-bottom hmf-body-m">We made your Favorites list accessible from our websites and app, allowing you
        <br> to be connected and synced with your favorite products wherever you are!</p>
        <p class="margin-bottom hmf-body-m">Sign in to save, view, and sync your favorite gear across devices.</p>
      }
      @if (isListRoute()) {
        <p class="hmf-header-bold-l">Sign in to Save & View Your Lists</p>
        <p class="margin-bottom hmf-body-m">We made your Lists accessible from our websites and app, allowing you
          <br> to be connected and synced with your favorite products wherever you are!</p>
          <p class="margin-bottom hmf-body-m">Sign in to save, view, and sync your favorite gear across devices.</p>
        }
      </div>
      <div class="center-text hmf-col hmf-span-12 hmf-mb-m">
        <button homefield-button class="primary-button hmf-body-bold-m" (click)="signIn()">SIGN IN</button>
        <button homefield-button class="secondary-button hmf-body-bold-m" (click)="createAccount()">CREATE ACCOUNT</button>
      </div>
    </div>
    <div>
      <shared-favorites-components-shop-by-category></shared-favorites-components-shop-by-category>
    </div>
